/**
 * Sliding window of up to 3 page numbers:
 * page 1–2 → 1 2 3 · page 3 → 2 3 4 · page 4 → 3 4 5 · end → … 8 9 10
 */
export function getVisiblePageNumbers(current: number, totalPages: number): number[] {
  if (totalPages <= 0) return [];
  if (totalPages <= 3) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  let start: number;
  if (current <= 2) {
    start = 1;
  } else if (current >= totalPages - 1) {
    start = totalPages - 2;
  } else {
    start = current - 1;
  }

  return [start, start + 1, start + 2];
}
